import React from 'react';
import classnames from 'classnames'
import ModalInner from '../layoutItems/modalInner';
import { withLocalize, Translate } from 'react-localize-redux';
import { Formik, Form, Field } from "formik";
import { selectDefaultStyles } from '../styling/selectDefaultStyles';
import BbDatePicker from "../common/datePicker";
import GreenSemaphore from "../../img/icons/GreenSemafor";
import YellowSemaphore from "../../img/icons/YellowSemafor";
import RedSemaphore from "../../img/icons/RedSemafor";
import BbFormikCheckbox from "../styling/bbFormikCheckbox";
import { BbSelectNoFormik } from '../styling/bbInput';
import { validateInput } from '../../store/storeFunctions';

class CustomEntityPopup extends React.Component {
    ratingOptions =
        [{ label: '', value: '' },
        { label: '1', value: '1' },
        { label: '2', value: '2' },
        { label: '3', value: '3' }];
    subjectTypeOptions =
        [{ label: this.props.translate('Charts.AddEntitySubjectTypeFO'), value: 'FO' },
        { label: this.props.translate('Charts.AddEntitySubjectTypePO'), value: 'PO' },
        { label: this.props.translate('Charts.AddEntitySubjectTypeFOP'), value: 'FOP' },
        { label: this.props.translate('Charts.AddEntitySubjectTypeAddress'), value: 'AD' },
        { label: this.props.translate('Charts.AddEntitySubjectTypeOther'), value: 'OT' }];
    defaultValues = {
        ...this.props.data,
        newAddress: '',
        newNote: ''
    }

    constructor(props) {
        super(props);
        this.state = {
            errors: {}
        };
    }

    formValid(values) {
        if (values.Name === '') {
            this.setState({
                errors: { Name: this.props.translate('Common.RequiredField') }
            });
            return false;
        }
        if (document.getElementById('addEntityDateOfBirth').value !== '' && document.getElementById('addEntityDateOfBirth').className.indexOf('is-danger') !== -1) {
            this.setState({
                errors: { DateOfBirthOrCreationDate: this.props.translate('Charts.InvalidDate') }
            });
            return false;
        }
        return true;
    }


    render() {
        return (
            <ModalInner title={this.props.entityPopupType === 'edit' ? this.props.translate('Charts.EditEntity') : this.props.translate('Charts.AddEntity')} close={this.props.close} >
                <Formik
                    initialValues={this.defaultValues}
                    enableReinitialize={true}
                >
                    {({ setFieldValue, values }) => (
                        <Form className="custom-popup-form">
                            <div className="row" style={{ paddingTop: '10px' }}>
                                <div className="col-md-4"><Translate id='Charts.AddEntitySubjectType' /></div>
                                <div className="col-md-8">
                                    <BbSelectNoFormik style={{ width: '100%' }} styles={selectDefaultStyles} name="EntityType"
                                        options={this.subjectTypeOptions} value={this.subjectTypeOptions.filter(option => option.value === values.EntityType)}
                                        onChange={(e) => setFieldValue('EntityType', e.value)} isDisabled={!values.CurrentUser}
                                    />
                                </div>
                            </div>
                            <div className="row" style={{ paddingTop: '5px' }}>
                                <div className="col-md-4"><Translate id='Charts.AddEntityName' /></div>
                                <div className="col-md-8"><Field className="input" type="text" name="Name" style={{ width: '100%' }} maxLength="300" disabled={!values.CurrentUser} onInput={(e) => validateInput(e)} />{this.state.errors.Name && <div style={{ color: 'red' }}>{this.state.errors.Name}</div>}</div>
                            </div>
                            <div className="row" style={{ paddingTop: '5px' }}>
                                <div className="col-md-4"><Translate id='Charts.AddEntityIco' /></div>
                                <div className="col-md-8"><Field className="input" type="text" name="IC" style={{ width: '100%' }} maxLength="25" disabled={!values.CurrentUser && this.defaultValues.IC !== ''} onInput={(e) => validateInput(e)} /></div>
                            </div>
                            <div className="row" style={{ paddingTop: '5px' }}>
                                <div className="col-md-4"><Translate id='Charts.AddEntityDateOfBirth' /></div>
                                <div className="col-md-8">
                                    <BbDatePicker
                                        afterDateChange={(d) => setFieldValue('DateOfBirthOrCreationDate', d)}
                                        value={values.DateOfBirthOrCreationDate}
                                        style={{ width: '100%' }}
                                        name="DateOfBirthOrCreationDate"
                                        id="addEntityDateOfBirth"
                                        disabled={!values.CurrentUser && this.defaultValues.DateOfBirthOrCreationDate !== null}
                                        yearsBack={120}
                                    />
                                    {this.state.errors.DateOfBirthOrCreationDate && <div style={{ color: 'red' }}>{this.state.errors.DateOfBirthOrCreationDate}</div>}
                                </div>
                            </div>
                            {values.data.Addresses.map((a, i) => (
                                <div className="row" style={{ paddingTop: '5px' }} key={i}>
                                    <div className="col-md-4"><Translate id='Charts.AddEntityAddress' /></div>
                                    <div className="col-md-8"><Field className="input" type="text" style={{ width: '100%' }} maxLength="300" name={`data.Addresses[${i}].Address`} disabled={a.UserId !== values.CurrentUserId} onInput={(e) => validateInput(e)} /></div>
                                </div>
                            ))}
                            <div className="row" style={{ paddingTop: '5px' }}>
                                <div className="col-md-4"><Translate id='Charts.AddNewEntityAddress' /></div>
                                <div className="col-md-8"><Field className="input" type="text" style={{ width: '100%' }} maxLength="300" name="newAddress" onInput={(e) => validateInput(e)} /></div>
                            </div>
                            <div className="row" style={{ paddingTop: '5px' }}>
                                <div className="col-md-4"><Translate id='Charts.AddEntityRating' /></div>
                                <div className="col-md-8">
                                    <BbSelectNoFormik style={{ width: '100%' }} styles={selectDefaultStyles} name="SemaphoreCode"
                                        options={this.ratingOptions} value={this.ratingOptions.filter(option => option.value === values.SemaphoreCode)}
                                        onChange={(e) => setFieldValue('SemaphoreCode', e.value)} formatOptionLabel={formatOptionLabel} isDisabled={!values.CurrentUser}
                                    />
                                </div>
                            </div>
                            {values.data.Notes.map((n, i) => (
                                <div className="row" style={{ paddingTop: '5px' }} key={i}>
                                    <div className="col-md-4"><Translate id='Charts.AddEntityNote' /></div>
                                    <div className="col-md-8"><Field className="input" type="text" style={{ width: '100%' }} maxLength="1024" name={`data.Notes[${i}].Note`} disabled={n.UserId !== values.CurrentUserId} onInput={(e) => validateInput(e)} /></div>
                                </div>
                            ))}
                            <div className="row" style={{ paddingTop: '5px' }}>
                                <div className="col-md-4"><Translate id='Charts.AddNewEntityNote' /></div>
                                <div className="col-md-8"><Field className="input" type="text" name="newNote" style={{ width: '100%' }} maxLength="1024" onInput={(e) => validateInput(e)} /></div>
                            </div>
                            <div className="row" style={{ paddingTop: '15px' }}>
                                <div className="col-md-6"><b><Translate id='Charts.ShareToGroups' /></b></div>
                                <div className="col-md-6"><b><Translate id='Charts.ShareToUsers' /></b></div>
                            </div>
                            <div className="row" style={{ paddingTop: '5px' }}>
                                <div className="col-md-6 custom-popup-chkgrp">
                                    {values.data.Groups.map((gr, i) => (
                                        <div key={i}>
                                            <BbFormikCheckbox label={gr.name} name={`data.Groups[${i}].checked`} id={`gr_${i}`} style={{ minHeight: 'unset' }} disabled={!values.CurrentUser} />
                                        </div>
                                    ))}
                                </div>
                                <div className="col-md-6 custom-popup-chkgrp">
                                    {values.data.Users.map((u, i) => (
                                        <div key={i}>
                                            <BbFormikCheckbox label={u.name} name={`data.Users[${i}].checked`} id={`u_${i}`} style={{ minHeight: 'unset' }} disabled={!values.CurrentUser} />
                                        </div>
                                    ))}
                                </div>
                            </div>
                            <div className="modal-inner-buttons" style={{ paddingTop: "1em" }}>
                                {this.props.entityPopupType === 'add' && <button id="addEntityBtn" type="button" onClick={() => { if (this.formValid(values)) { this.props.newCustomRelation(values); this.props.close() } }} className={classnames('bb-button gradient-1', { 'is-square': localStorage.locales_button_style === 'square' })}><Translate id="Charts.AddBtn" /></button>}
                                {this.props.entityPopupType === 'edit' && <button id="editEntityBtn" type="button" onClick={() => { if (this.formValid(values)) { this.props.editCustomEntity(values); this.props.close() } }} className={classnames('bb-button gradient-1', { 'is-square': localStorage.locales_button_style === 'square' })}><Translate id="Charts.Save" /></button>}
                            </div>
                        </Form>
                    )}
                </Formik>
            </ModalInner>
        )
    }
}

const formatOptionLabel = ({ value }) => (
    <div style={{ display: "flex" }}>
        <span style={{ display: "inline-flex", alignItems: "center" }}>
            {value === '' && <><Translate id="Charts.AddEntityRatingNoRating" /></>}
            {value === '1' && <><GreenSemaphore style={{ width: "25px" }} /> &nbsp; <Translate id="Charts.AddEntityRatingGreen" /></>}
            {value === '2' && <><YellowSemaphore style={{ width: "25px" }} /> &nbsp; <Translate id="Charts.AddEntityRatingOrange" /></>}
            {value === '3' && <><RedSemaphore style={{ width: "25px" }} /> &nbsp; <Translate id="Charts.AddEntityRatingOrange" /></>}
        </span>
    </div>
);

export default withLocalize(CustomEntityPopup);
